// Environment Configuration
export interface EnvironmentConfig {
  name: string;
  apiBaseUrl: string;
  database: {
    host: string;
    port: string;
    name: string;
    username: string;
    password: string;
  };
}

export const environments: Record<string, EnvironmentConfig> = {
  dev: {
    name: 'Development',
    apiBaseUrl: 'http://localhost/tailorstitchpro/backend/api',
    database: {
      host: 'localhost',
      port: '3306',
      name: 'TailorStitchPro',
      username: 'root',
      password: 'A@dm1n#2024Secure!'
    }
  },
  demo: {
    name: 'Demo',
    apiBaseUrl: 'https://lahari.site/tailorDemo/backend/api',
    database: {
      host: 'localhost',
      port: '3306',
      name: 'TailorStitchPro_Demo',
      username: 'root',
      password: 'A@dm1n#2024Secure!'
    }
  },
  prod: {
    name: 'Production',
    apiBaseUrl: 'https://stitchpro.laharisoftwares.com/backend/api',
    database: {
      host: 'localhost',
      port: '3306',
      name: 'u847870395_stitchpro',
      username: 'u847870395_stitchpro',
      password: '0w!L?qn6O'
    }
  }
};

// Get current environment - MANUAL CONTROL
export const getCurrentEnvironment = (): string => {
  // Check for environment variable first
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }
  
  // Manual environment setting - CHANGE THIS MANUALLY
  return 'prod'; // Options: 'dev', 'demo', 'prod'
};

// Get current environment config
export const getCurrentConfig = (): EnvironmentConfig => {
  const env = getCurrentEnvironment();
  return environments[env] || environments.dev;
};

// Environment detection helpers
export const isDev = (): boolean => getCurrentEnvironment() === 'dev';
export const isDemo = (): boolean => getCurrentEnvironment() === 'demo';
export const isProd = (): boolean => getCurrentEnvironment() === 'prod';
